import { FC } from 'react';
import { Page } from 'layouts/Page';
import { CreditNoteDetails } from 'components/CreditNotes/CreditNoteDetails';

export const CreditNoteDetailsPage: FC = () => {
	return (
		<Page title="Credit Note Details – EAS Control Center">
			<CreditNoteDetails />
		</Page>
	);
};
